import { render } from "./bank-modal.vue?vue&type=template&id=36521920"
import script from "./bank-modal.vue?vue&type=script&lang=js"
export * from "./bank-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__